/**
 * Vendor-neutral browser events.
 */
export function emit(name, detail = {}) {
	const payload = {
		sourceUrl: typeof window !== 'undefined' ? window.location.href : '',
		errorCode: '',
		...detail,
	};

	document.dispatchEvent(
		new CustomEvent(name, {
			detail: payload,
			bubbles: true,
		})
	);
}
